import { useRouter } from 'next/router';
import { useIntl } from 'react-intl';

type ShareResult = {
    iconSrc: string;
    label: string;
    href: string;
};

export const useShareVideoPlatforms = (): {
    platforms: Array<ShareResult>;
    href: string;
    shareText: string;
} => {
    const router = useRouter();
    const currentPath = router.asPath;
    const currentUrl =
        typeof window !== 'undefined' ? `${window.location.origin}${currentPath}` : currentPath;
    const { formatMessage } = useIntl();
    const baseMessage = formatMessage({ id: 'catalog.share.video' });
    const shareText = `${baseMessage}${currentUrl}`;

    const shareLinks: Array<ShareResult> = [
        {
            iconSrc:
                'https://bk-public-prod.storage.googleapis.com/public/static/logo/logo-whatsapp.png',
            label: 'WhatsApp',
            href: `https://wa.me/?text=${encodeURIComponent(shareText)}`
        },
        {
            iconSrc:
                'https://bk-public-prod.storage.googleapis.com/public/static/logo/logo-email.png',
            label: 'Email',
            href: `mailto:?subject=${encodeURIComponent(shareText)}`
        },
        {
            iconSrc:
                'https://bk-public-prod.storage.googleapis.com/public/static/logo/logo-linkedin.png',
            label: 'LinkedIn',
            href: `https://www.linkedin.com/sharing/share-offsite/?mini=true&url=${encodeURIComponent(currentUrl)}&title=${encodeURIComponent(baseMessage)}`
        },
        {
            iconSrc:
                'https://bk-public-prod.storage.googleapis.com/public/static/logo/logo-facebook.png',
            label: 'Facebook',
            href: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(currentUrl)}`
        }
    ];

    return { platforms: shareLinks, href: currentUrl, shareText };
};
